import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import styles from './index.module.scss'
import ListView from "../../../Project/components/ListView";
import ProjectService from "../../../../services/project.service";
import {useWorkspace} from "../../../../context/workspace.context";
import ChevronDownIcon from "../../../../components/icons/ChevronDownIcon";
import { extractTaskList } from "../../../../utils/taskList";

const TaskList = ({activeProjects, setGlobalTaskList, assigneeIds = [], assigneesInitialized = false, filterParams = {}, projects = [], projectUsers = []}: any) => {
    const { workspace } = useWorkspace()
    const [taskList, setTaskList] = useState<any[]>([])
    const [isCollapsed, setIsCollapsed] = useState(false)
    const requestRef = useRef(0)

    const project = useMemo(() => {
        const activeProjectId = activeProjects[0]
        return projects.find((item: any) => String(item.id) === String(activeProjectId)) || projects[0] || null
    }, [activeProjects, projects])

    const getTaskList = useCallback(async () => {
        const requestId = ++requestRef.current
        const projectId = activeProjects[0]

        if(!workspace?.id || !projectId || !assigneesInitialized || assigneeIds.length === 0){
            setTaskList([])
            return
        }

        try {
            const requestParams = {
                workspace_id: workspace.id,
                project_ids: activeProjects,
                assignee_ids: assigneeIds,
                ...filterParams,
            }
            const tasksResponse = await ProjectService.getAllProjectWorkSpaceTasks(requestParams)

            if (requestId !== requestRef.current) return

            const projectById = new Map(projects.map((item: any) => [String(item.id), item]))
            setTaskList(extractTaskList(tasksResponse).map((task: any) => {
                const taskProjectId = task.project_id ?? task.project?.id
                const projectSummary = projectById.get(String(taskProjectId))

                return {
                    ...task,
                    project: task.project || projectSummary || {
                        id: taskProjectId,
                        name: task.project_name || 'Проект',
                    },
                }
            }))
        } catch (error) {
            if (requestId !== requestRef.current) return
            console.error('Failed to load statistic tasks:', error)
            setTaskList([])
        }
    }, [activeProjects, assigneeIds, assigneesInitialized, filterParams, projects, workspace?.id])

    useEffect(() => {
        setGlobalTaskList(taskList)
    }, [taskList])

    useEffect(() => {
        void getTaskList()
    }, [getTaskList])

    if(!project){
        return null
    }

    return (
        <div className={styles.taskList}>
            <button
                type="button"
                className={styles.taskList__title}
                onClick={() => setIsCollapsed((current) => !current)}
                aria-expanded={!isCollapsed}
            >
                <span>Задачи</span>
                <span className={`${styles.taskList__chevron} ${!isCollapsed ? styles.expanded : ''}`}>
                    <ChevronDownIcon/>
                </span>
            </button>
            <div className={`${styles.taskList__body} ${isCollapsed ? styles.hidden : ''}`}>
                <ListView
                    tasks={taskList}
                    getTasks={getTaskList}
                    project={project}
                    projectUsers={projectUsers}
                    canPersistOrder={false}
                    includeChildTasks
                />
            </div>
        </div>
    )
}

export default TaskList;
